import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import { followupList } from "reduxStore/action/followUpActions";
import { getFollowupStatus } from "reduxStore/action/masterActions";
import { handleListResponse, seo } from "utils/utils";
import TableDataNotFound from "component/TableDataNotFound";
import moment from "moment";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import Pagination from "component/common/Pagination";
import usePage from "utils/usePage";

const TodayFollowupIndex = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [followupListData, setFollowupListData] = useState([]);
  const [page, setPage] = usePage();
  // const [formValid, setFormValid] = useState({}); 
  // const [endDateDisable, setEndDateDisable] = useState(true);
  // const [followupStatusData, setFollowupStatusData] = useState([]);

  const getDefaultDateRange = () => {
    const today = moment().format("YYYY-MM-DD");
    return { start_date: today, end_date: today };
  };

  const defaultDates = getDefaultDateRange();

  const [form, setForm] = useState({
    start_date: defaultDates.start_date,
    end_date: defaultDates.end_date,
    limit: "",
    offset: "",
    followup_status: "",
    followup_for: "",
    todayFollowup: true,
  });

  const followupListSelector = useSelector((state) => state?.followUp) || [];
  // const followupStatus = useSelector((state) => state.followupstatus);

  const { view, edit, isAdmin } = usePermission({
    view: "view_follow",
    edit: "edit_follow",
  });

  const navigatpage = async (navname) => {
    navigate(navname);
  };

  useEffect(() => {
    dispatch(
      followupList({
        limit: 10,
        offset: 0,
        ...defaultDates,
        todayFollowup: true,
      })
    );
  }, []);

  useEffect(() => {
    if (followupListSelector?.response?.status === 200) {
      const data = followupListSelector?.response?.data || [];
      setFollowupListData(handleListResponse(data) ? data : []);
    } else {
      setFollowupListData([]);
    }
  }, [followupListSelector]);

  useEffect(() => {
    dispatch(getFollowupStatus());
  }, []);

  // useEffect(() => {
  //   if (followupStatus?.response?.status === 200) {
  //     setFollowupStatusData(followupStatus.response.data);
  //   } else {
  //     setFollowupStatusData([]);
  //   }
  // }, [followupStatus]);

  // Handle pagination
  const handlePageClick = (newOffset) => {
    const { start_date, end_date } =
      form.start_date && form.end_date ? form : getDefaultDateRange();

    setPage(newOffset);
    dispatch(
      followupList({
        ...form,
        start_date: start_date,
        end_date: end_date,
        offset: newOffset,
        limit: 10,
        todayFollowup: true,
      })
    );
  };

  // Form validation
  // const handleValid = () => {
  //   let errors = { ...formValid };
  //   let formError = false;

  //   if (form.start_date && !form.end_date) {
  //     formError = true;
  //     errors["end_date"] = strings.endDateErr;
  //   }

  //   setFormValid(errors);
  //   return formError;
  // };

  // Search filter
  // const filterDetail = () => {
  //   if (!handleValid()) {
  //     const { start_date, end_date } =
  //       form.start_date && form.end_date ? form : getDefaultDateRange();

  //     dispatch(
  //       followupList({
  //         ...form,
  //         start_date: start_date,
  //         end_date: end_date,
  //         offset: 0,
  //         limit: 10,
  //         todayFollowup: true,
  //       })
  //     );
  //     setPage(0);
  //   }
  // };

  // Reset filter
  // const filterReset = () => {
  //   const { start_date, end_date } = getDefaultDateRange();
  //   const resetForm = {
  //     start_date,
  //     end_date,
  //     followup_status: "",
  //     followup_for: "",
  //     limit: "10",
  //     offset: "0",
  //     todayFollowup: true,
  //   };
  //   setForm(resetForm);
  //   setFormValid({});
  //   dispatch(followupList({ ...resetForm }));
  //   setPage(0);
  // };

  // Handle input change
  // const handleInputField = (e) => {
  //   const { name, value } = e.target;
  //   setForm((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  //   if (name === "end_date") {
  //     setFormValid((prev) => ({ ...prev, end_date: "" }));
  //   }
  // };

  // Enable/disable end_date
  // useEffect(() => {
  //   setEndDateDisable(!form.start_date);
  // }, [form.start_date]);

  // SEO setup
  useEffect(() => {
    seo({
      title: "Followup Listing",
      metaDescription: "Followup listing",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.todayFollowup}
        titleactive={strings.todayFollowupList}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            {/* <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              // max={form.end_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formValid.end_date && (
                            <span style={{ color: "red" }}>
                              {formValid.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByType}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="followup_for"
                            value={form.followup_for}
                            onChange={handleInputField}
                          >
                            <option value={""}>{strings.selectType}</option>
                            <option value={1}>{strings.lead}</option>
                            <option value={2}>{strings.siteVisit}</option>
                            <option value={3}>{strings.booking}</option>
                            <option value={4}>{strings.registration}</option>
                          </select>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByStatus}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="followup_status"
                            value={form.followup_status}
                            onChange={handleInputField}
                          >
                            <option value={""}>{strings.selectstatus}</option>
                            {followupStatusData?.length ? (
                              followupStatusData.map((item, index) => (
                                <option key={index} value={item._id}>
                                  {item.title}
                                </option>
                              ))
                            ) : (
                              <option>{strings.Loading}</option>
                            )}
                          </select>
                        </div>
                        <div className="col-md-8 pt-4">
                          <div className="form-group d-flex justify-content-end">
                            <button
                              className="btn btn-warning mr-4"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.listOfTodayFollowup}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead>
                        <tr className="text-center">
                          <th scope="col">{strings.propertyName}</th>
                          <th scope="col">{strings.createdDate}</th>
                          <th scope="col">{strings.status}</th>
                          <th scope="col">{strings.followupDateTime}</th>
                          <th scope="col">{strings.visitorName}</th>
                          <th scope="col">{strings.visitingScore}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {followupListData?.length ? (
                          followupListData.map((item, index) => {
                            return (
                              <tr className="text-center" key={index}>
                                <td style={{ inlineSize: "130px" }}>
                                  {item?.property_title
                                    ? item?.property_title
                                    : "-"}
                                </td>
                                <td>
                                  {moment(item.followup_date).format(
                                    "DD-MM-yyyy hh:mm A"
                                  )}{" "}
                                </td>
                                <td>{item.followup_status}</td>

                                <td>
                                  {item.next_followup_date
                                    ? `${moment(item.next_followup_date).format(
                                        "DD-MM-yyyy"
                                      )}  & 
                                    ${item.followup_time}`
                                    : "-"}
                                </td>
                                <td style={{ inlineSize: "130px" }}>
                                  {item.customer_first_name}
                                </td>
                                <td>{item.visit_score}</td>
                                <td className="p-2">
                                  {view && (
                                    <i
                                      className="fa fa-eye theme-fa-icon p-2"
                                      aria-hidden="true"
                                      title={strings.viewfollowup}
                                      onClick={() => {
                                        navigatpage(
                                          `/viewfollowup/${item._id}`
                                        );
                                      }}
                                    ></i>
                                  )}
                                  {!isAdmin &&
                                    edit &&
                                    item.followup_status ===
                                      "Next day call" && (
                                      <i
                                        className="fa fa-edit theme-fa-icon  p-1"
                                        aria-hidden="true"
                                        title="Edit Followup"
                                        onClick={() => {
                                          navigatpage(
                                            `/editfollowup/${item._id}`
                                          );
                                        }}
                                      ></i>
                                    )}
                                  {view && (
                                    <i
                                      className="fa fa-history theme-fa-icon p-1"
                                      aria-hidden="true"
                                      title={strings.viewHistory}
                                      onClick={() => {
                                        navigatpage(
                                          `/allfollowup/${item.lead_id}`
                                        );
                                      }}
                                    ></i>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={followupListData} />
                  </div>
                  <Pagination
                    totalCount={followupListSelector?.response?.total_data}
                    listData={followupListData}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TodayFollowupIndex;
